import { Table, Text } from '@mantine/core';

import { useArchiveRefuseReason } from '../../api/archiveRefuseReason';
import { useRestoreRefuseReason } from '../../api/restoreRefuseReason';
import { dictionaryTypes } from '../../types';
import { ArchiveToggle } from '../ArchiveToggle';

type Props = {
  refuseReason: dictionaryTypes.RefuseReason;
};

export const RefuseReasonsRow = ({ refuseReason }: Props) => {
  const archive = useArchiveRefuseReason();
  const restore = useRestoreRefuseReason();

  const isArchived = Boolean(refuseReason.archivedAt);

  return (
    <Table.Tr>
      <Table.Td>
        <Text size="sm">{refuseReason.text}</Text>
      </Table.Td>
      <Table.Td>
        <ArchiveToggle
          isArchived={isArchived}
          isLoading={isArchived ? restore.isLoading : archive.isLoading}
          onArchive={() => archive.mutate({ _id: refuseReason._id })}
          onRestore={() => restore.mutate({ _id: refuseReason._id })}
        />
      </Table.Td>
    </Table.Tr>
  );
};
